export const AUTH_STORAGE_KEY = 'auth_session';
export const USER_PROFILE_STORAGE_KEY = 'user_profile';
